import React, {useEffect, useMemo, useRef, useState} from 'react';
import {getCodes} from "../../../../api/code/CodeService";
import {getFields} from "../../../../api/field/FieldService";
import {useNavigate} from "react-router-dom";
import CreateAttachPanel from "../../../../components/files/CreateAttachPanel";
import {
    buildCommonInfoFieldDefs,
    buildMaintenanceFieldDefs,
    chunkFieldsIntoRows,
    CommonInfoPanel,
    fieldsToKvCells,
    MaintenancePanel,
} from "./shared/assetDetailKv";
import {useAssetCreateEdit} from "./shared/useAssetCreateEdit";
import "./subPages/view/assetInfo.css";
import {createAsset} from "../../../../api/asset/AssetService";
import {
    createGroupSelect,
    getCustomCodeList,
    getCustomStringList,
    getGroupSelectList
} from "../../../../api/field/CustomCodeService";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {
    getFlatCode,
    isAdmin,
    isMobile,
    reversedFlatCode,
    validationChecker,
} from "../../../../components/commonmethod/CommonMethod";
import {CacheType} from "../../../../constant/CodeSpecNum";
import {apiLoading} from "../../../../redux/slice/apiSlice";
import {useDispatch, useSelector} from "react-redux";
import {useCacheRefresh} from "../../../../hooks/useCacheRefresh";
import {useCodeHandlers} from "../../../../hooks/useCodeHandlers";
import CommonDrawerContainer from "../../../../components/drawer/simms/CommonDrawerContainer";
import {
    CustomDataButtonTrigger,
    CustomDataContainer,
    CustomFieldContainer
} from "../../../../components/drawer/simms/CustomDataContainer";
import {ContentDetailTwoColLayout, DetailFormPageShell, DetailListPage, DetailSummaryButton} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";


/**
 * &자산 &자산등록 &자산생성
 * */

function AssetCreate() {
    const platFrom = useSelector(state => state.auth.platFrom);
    const user = useSelector((state) => state.auth.user);

    const isAdminUser = isAdmin(user);
    const {handleCodeCreate, handleCustomCodeCreate} = useCodeHandlers();
    const codeUpdater = useMemo(
        () => (isAdminUser ? {onCreate: handleCodeCreate} : undefined),
        [isAdminUser, handleCodeCreate],
    );
    const customCodeUpdater = useMemo(
        () => (isAdminUser ? {onCreate: handleCustomCodeCreate} : undefined),
        [isAdminUser, handleCustomCodeCreate],
    );

    const [asset, setAsset] = useState({operator: [], handler: []});
    const [fieldFromDB, setFieldFromDB] = useState([]);     //=> DB에서 가져온 자산그룹별 추가필드 전체
    const [fieldsData, setFieldsData] = useState([]);       //=> 전체추가필드 중 선택한 자산그룹에 해당하는 추가필드 리스트를 담을 변수
    const [code, setCode] = useState();
    const [ccFromDB, setCcFromDB] = useState([]);           //=> DB에서 가져온 공통코드 전체
    const [csFromDB, setCsFromDB] = useState([]);           //=> DB에서 가져온 공통필드 전체
    const [groupSelect, setGroupSelect] = useState([]);
    const currentDate = new Date();
    const [docs, setDocs] = useState([]);
    const dispatch = useDispatch();
    const refreshCache = useCacheRefresh();
    const requireds = ["assetName"]
    const [date, setDate] = useState({
        from: currentDate.toISOString(),
        to: '',
    });
    let flat = getFlatCode(code);

    const create = async () => {
        console.log(asset)
        if (!isAdminUser) {
            alert("[관리자] 권한이 필요합니다.");
            return;
        }
        if (!validationChecker(asset)) {
            return;
        }

        if (requireds.some(e => !asset[e])) {
            alert("필수값이 누락되었습니다.")
            return
        }
        dispatch(apiLoading(true))
        const docFile = []
        docs.forEach(each => docFile.push(each.object))

        try {
            const response = await createAsset(asset, [], docFile);

            if (response.status === 200) {
                refreshCache(CacheType.asset);
                alert("등록 되었습니다.")
                navigate(`/asset/${response.data.id}`, {state: {id: response.data.id}})
            } else if (response.status === 201 || (response.status === 202)) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 413) {
                handleActiveError({message: "첨부파일 용량이 너무 큽니다."});
            } else {
                handleActiveError({message: "등록에 실패하였습니다."});
            }
        } catch (error) {

        } finally {
            dispatch(apiLoading(false))
        }
    }

    const navigate = useNavigate();
    useEffect(() => {
        getFields().then(response => setFieldFromDB(response.data));
        getCustomCodeList().then(response => {
            setCcFromDB(response.data);
        });
        getCustomStringList().then(response =>  { setCsFromDB(response.data)});
        getCodes().then(response => setCode(response.data.content));
        getGroups().then(r => setGroupSelect([{ id: null, name: "선택" }, ...r.data]));
    }, [])

    // 같은 groupId일 시 랜더링 시 기존값이 초기화되지 않도록 수정
    const prevGroupIdRef = useRef(null);
    useEffect(() => {
        if (asset?.group) {
            if (prevGroupIdRef.current !== asset.group.id) {
                if ('assetFields' in asset) {
                    delete asset.assetFields;
                }
                prevGroupIdRef.current = asset.group.id;
            }

            if (flat) {
                const matchedCode = flat.find(each => each.id === asset.group.id);
                const codes = reversedFlatCode(matchedCode, flat);
                setFieldsData(fieldFromDB.filter(each =>
                    codes.includes(each.code.id)
                ));
            }
        } else {
            setFieldsData([]);
            prevGroupIdRef.current = null;
        }
    }, [asset?.group, fieldFromDB])

    async function getGroups() {
        return await getGroupSelectList();
    }

    const renewFields = () => {
        getFields().then(response => setFieldFromDB(response.data));
    }

    const renewCustomData = () => {
        getCustomCodeList().then(response => {
            setCcFromDB(response.data);
        });
        getCustomStringList().then(response => {
            setCsFromDB(response.data)
        });
    }

    const renewGroupSelect = () => {
        getGroups().then(r => setGroupSelect([{ id: null, name: "선택" }, ...r.data]));
    }

    const handleCreateSelectBox = async (inputData, modal) => {
        const data = {
            name : inputData,
            parent : {id : modal.parent}
        };

        const _ = await createGroupSelect(data);
        if (_.status === 200) {
            handleActiveToast({
                description: "", message: "등록 되었습니다.", labelListener: () => {
                }
            })

        }else if(_.status ===201 ||(_.status === 202)){
            handleActiveError({message: _.data.title, description: _.data.reason});
        }else  {
            handleActiveToast({
                description: "알 수 없는 에러.", message: "등록할 수 없습니다..", labelListener: () => {
                }
            })
        }

        return _;
    }

    const assetForForm = useMemo(
        () => ({
            ...asset,
            createdAt: date.from,
            updatedAt: date.to,
        }),
        [asset, date],
    );

    const {renderEdit} = useAssetCreateEdit({
        asset,
        setAsset,
        date,
        ccFromDB,
        csFromDB,
        fieldsData,
        groupSelect,
        codeUpdater,
        customCodeUpdater,
        isAdminUser,
        renewGroupSelect,
        handleCreateSelectBox,
    });

    const commonInfoRows = useMemo(() => {
        const defs = buildCommonInfoFieldDefs(assetForForm, platFrom, ccFromDB, csFromDB);
        return chunkFieldsIntoRows(defs).map((rowDefs, index) => {
            const cells = fieldsToKvCells(rowDefs, true, renderEdit);
            const key = rowDefs.map((d) => d.editArgs?.[0]?.id ?? d.editKey ?? d.label).join("-");
            return {key: key || `common-row-${index}`, cells};
        });
    }, [assetForForm, platFrom, ccFromDB, csFromDB, renderEdit]);

    const maintenanceRows = useMemo(() => {
        const defs = buildMaintenanceFieldDefs(assetForForm, fieldsData);
        return chunkFieldsIntoRows(defs).map((rowDefs, index) => {
            const cells = fieldsToKvCells(rowDefs, true, renderEdit);
            const key = rowDefs.map((d) => d.editArgs?.[0]?.id ?? d.editKey ?? d.label).join("-");
            return {
                key: key || `maint-row-${index}`,
                cells,
                rowAuto: rowDefs.some((d) => d.rowAuto),
            };
        });
    }, [assetForForm, fieldsData, renderEdit]);

    const maintenanceFooter =
        isAdminUser && asset.group ? (
            <div className="asset-detail-create-field-admin flex justify-center items-center py-2 border-t border-[#e5e5e5]">
                                            <CommonDrawerContainer
                                                title="자산그룹필드 등록"
                                                auth={isAdminUser}
                                                trigger={CustomDataButtonTrigger}
                                                Component={CustomFieldContainer}
                                                ComponentProps={{
                                                    code: asset.group,
                                                    onCreate: renewFields,
                                                }}
                                            />
                                        </div>
        ) : null;

    return (
        <DetailFormPageShell
            className={`common-container ${isMobile ? "" : "container-height-full"} border-l-gray create-page detail-list-layout asset-detail-list-layout`}
            title="자산등록"
            meta="신규 자산 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/asset/list")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className={`container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col ${isMobile ? "" : "overflow-hidden"}`}>
                    <ContentDetailTwoColLayout
                        main={
                            <>
                                <CommonInfoPanel rows={commonInfoRows} isEditing />
                                <MaintenancePanel rows={maintenanceRows} isEditing footer={maintenanceFooter} />
                            </>
                        }
                        aside={<CreateAttachPanel docs={docs} setDocs={setDocs} />}
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export default AssetCreate;
